module.exports = __webpack_public_path__ + "img/xlaxiata.53de90b1.webp";